import { t } from '../../../../src/common/i18n'


export function validatePhone(phoneNumber) {
  const phone = phoneNumber.replace(/\s|-/g, '')

  if (phone.match(/[a-zA-Z]+/)) {
    return this.createError({
      path: 'phone',
      message: t('validations.register.phone_invalid_letters'),
    })
  }

  if (phone.match(/^\+376/) && phone.length !== 10) {
    return this.createError({
      path: 'phone',
      message: t('validations.register.phone_invalid_france'),
    })
  }

  if (phone.match(/^\+34/) && phone.length !== 12) {
    return this.createError({
      path: 'phone',
      message: t('validations.register.phone_invalid_spain'),
    })
  }

  if (phone.charAt(0) === '+' && phone.length < 10) {
    return this.createError({
      path: 'phone',
      message: t('validations.register.phone_invalid_too_small'),
    })
  }

  if (phone.charAt(0) !== '+' && phone.length !== 9) {
    return this.createError({
      path: 'phone',
      message: t('validations.register.phone_invalid_not_spanish'),
    })
  }

  if (phone.length > 15) {
    return this.createError({
      path: 'phone',
      message: t('validations.register.phone_invalid_too_long'),
    })
  }

  if (!phone.match(/^[+6789]+/)) {
    return this.createError({
      path: 'phone',
      message: t('validations.register.phone_invalid_wrong_start'),
    })
  }

  return true
}
